import React from 'react';
import {render, createStore} from '../src/frame';
import ChildPage from './Child';
import Action1 from './action';

const Home = render({
    actions: {
        action1: Action1,
    },
    models: ['m1']
})(({props, state, action}) => {

    const {m1} = props;

    return (
        <div>
            <div>{m1.name}</div>
            <div>{m1.info.age}</div>
            <div>{m1.info.school.grade}</div>
            <ChildPage />
        </div>
    );
});

export default Home